import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "./home.scss";
import Widget from "../../components/widget/Widget";
import Users from "../../components/users/Userstable";
import SomeComponent from "../../components/SomeComponent";

const Home = () => {
  return (
    <div className="home">
      <Sidebar />
      <div className="homeContainer">
        <Navbar />
        <div className="widgets">
          <Users />
        </div>
      </div>
    </div>
  );
};

export default Home;
